import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './RadioPick.module.scss'
import classNames from 'classnames'

export class RadioPick extends Component {
  handleChange = option => () => {
    this.props.onChange && this.props.onChange(option)
  }

  render () {
    const { options, value, showDivider, size } = this.props

    return (
      <div className={styles.component}>
        {options.map((option, index) => (
          <div
            className={classNames(styles.option, {
              [styles.divider]: showDivider,
              [styles.small]: size === 'small',
              [styles.selectedOption]: value && value.value === option.value
            })}
            key={index}
            onClick={this.handleChange(option)}>
            <div className={styles.bullet} />
            <div className={styles.label}>
              {option.label}
            </div>
          </div>
        ))}
      </div>
    )
  }
}

RadioPick.propTypes = {
  /** onChange event */
  onChange: PropTypes.func.isRequired,
  /** Radio pick options */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  /** Value object, uses the same object format as 'options' property */
  value: PropTypes.object,
  /** Show divider between options */
  showDivider: PropTypes.bool,
  /* Size of input font */
  size: PropTypes.oneOf(['small', 'default'])
}

RadioPick.defaultProps = {
  showDivider: false,
  size: 'default'
}

export default RadioPick
